import React, { useState, useEffect, useRef } from 'react'

import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import { Button, Card, Table, Tooltip } from 'antd';
import ImputComponent from "../../../../InputComponent"
import { useLanguage } from '../../../../../store/languageContext';
import { LanguageFactory } from '../../../../../factories'; 
import SearchDebounceBar from '../../../../SearchDebounce';
import { PropertySearch } from '../../../../../factories/propertySearchs';
import PageContainer from '../../../../CSIComponents/PageContainer';
import { sortHelper } from '../../../../../helpers/misc/sortHelper'


const GPTable = (props: any) => {
    const { language } = useLanguage()
    const lang = new LanguageFactory(language)
    const initialRender = useRef(true);
    const [searchs, setSearch] = useState<string[]>([]);
    const [dataSource, setDataSource] = useState<Array<any>>([]);
    const [total, setTotal] = useState(dataSource?.length || 0)
    const [data, setData] = useState(dataSource);
    const columns = [
        {
            title: '',
            key: 'index',
            render: (text: string, record: [], index: number) => index += 1,
            width: '40px'
        },
        {
            title: 'Policy Name',
            dataIndex: 'policyname',
            key: 'policyname',
            ellipsis: {
                showTitle: false,
            },
            sorter: (a: [], b: []) => sortHelper(a, b, 'policyname'),
            showSorterTooltip: false
        },
        {
            title: 'Code',
            dataIndex: 'policycode',
            key: 'policycode',
            ellipsis: {
                showTitle: false,
            },
            sorter: (a: [], b: []) => sortHelper(a, b, 'policycode'),
            showSorterTooltip: false
        },
        {
            title: 'Start Date',
            dataIndex: 'startdate',
            key: 'startdate',
            sorter: (a: [], b: []) => sortHelper(a, b, 'startdate'),
            showSorterTooltip: false
        },
        {
            title: 'End Date',
            dataIndex: 'enddate',
            key: 'enddate',
            sorter: (a: [], b: []) => sortHelper(a, b, 'enddate'),
            showSorterTooltip: false
        },
        {
            title: 'Type',
            dataIndex: 'policytype',
            key: 'policytype',
            ellipsis: {
                showTitle: false,
            },
            sorter: (a: [], b: []) => sortHelper(a, b, 'policytype'),
            showSorterTooltip: false
        },
    ]

    const onChangeSearch = (term: string) => {
        setSearchTerm(term)
        onDebounce(term)
    }
    const {
        searchTerm, setSearchTerm, searchTermDebounced, onDebounce
    } = SearchDebounceBar()
    const recentlySearchs = () => {
        return searchs.map((search, index) => {
            return (
                <span key={index} onClick={() => recoverSearch(search)}>
                    &nbsp;{search}{searchs.length - 1 === index ? '.' : ','}
                </span>
            )
        })
    }

    const recoverSearch = (search: string) => {
        setSearchTerm(search)
        filterData(search)
        onDebounce(search)
    }

    const saveNewSearch = (term: string) => {
        const stackSearchs = new PropertySearch(searchs)
        setSearch(stackSearchs.add(term))
    }

    const afterDebounce = (term: string) => {
        if (term) {
            saveNewSearch(term)
        }
        filterData(term)
    }

    const getData = async () => {
        const sourceData = props?.detailData?.policies?.guaranteepolicy || []
        setDataSource(sourceData);
        setData(sourceData)
    }
    useEffect(() => {
        getData()
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [])
    const filterData = async (query: string) => {
        const filterData = data.filter((item: any) => {
            const itemData: any = {}
            columns.forEach((col: any) => {
                if (typeof item[col.dataIndex] === 'string') {
                    itemData[col['dataIndex']] = item[col.dataIndex].toLowerCase();
                }
            })

            return JSON.stringify(itemData)
                .indexOf(query.toLocaleLowerCase()) > -1;

        })

        setDataSource(filterData);
    }

    useEffect(() => {
        setTotal(dataSource.length)
    }, [dataSource])
    // search functionality
    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        } else {
            afterDebounce(searchTermDebounced);
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [searchTermDebounced])
    return (<PageContainer>
        <Card style={{ marginTop: -15 }}>
            <Grid container spacing={0} className="containerSpacing py-0">
                <Grid item xs={12} className="p-0">
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>Guarantee Payment</div>
                        <div><Button className="db-add-btn" onClick={() => { props.isEditable(); props.changeTab('GuaranteePaymentAdd'); }}>Add</Button></div>
                    </div>
                </Grid>
                <Grid item xs={4} className="pb-0 px-0 my-0">
                    <ImputComponent
                        className='SearchBar'
                        label='Search'
                        labelShrink={true}
                        value={searchTerm}
                        onChange={onChangeSearch}
                        placeholder='Search Guarantee Payment'
                        endAdornment={<SearchIcon style={{ color: '#9a9a9a' }} />}
                    />
                    <div className="recentlySearchs">
                        <p>{lang.translate(language, 'recently_searched')}: {recentlySearchs()}</p>
                    </div>
                </Grid>
                <Grid item xs={12} className="p-0">
                    <Table
                        columns={columns}
                        dataSource={
                            dataSource
                        }
                        pagination={{
                            size: "small",
                            total,
                            showSizeChanger: true,
                            showTotal: (total, range) => `Total ${total} items, Current ${range[0]}-${range[1]}`,
                            defaultPageSize: 10,
                            defaultCurrent: 1,
                            onChange: (page, pageSize) => {
                                console.log(page + '===' + pageSize)
                            }
                        }}
                        onRow={record => {
                            return {
                                onClick: () => {
                                    let _record = record
                                    // @ts-expect-error explanation: table error type as by defult antd is expecting an empty array
                                    if(!record.paymentaddress || record.paymentaddress.length === 0){
                                    // @ts-expect-error explanation: table error type as by defult antd is expecting an empty array
                                        _record.paymentaddress = [{}]
                                    }
                                    // @ts-expect-error explanation: table error type as by defult antd is expecting an empty array
                                    if(!record.acceptedpayments || record.acceptedpayments.length === 0){
                                    // @ts-expect-error explanation: table error type as by defult antd is expecting an empty array
                                        _record.acceptedpayments= [{}]
                                    } 
                                    // @ts-expect-error explanation: table error type as by defult antd is expecting an empty array
                                    if(!record.descriptions || record.descriptions.length === 0){
                                        // @ts-expect-error explanation: table error type as by defult antd is expecting an empty array
                                        _record.descriptions= [{}]
                                    } 
                                    // @ts-expect-error explanation: table error type as by defult antd is expecting an empty array
                                    if(!record.paymentaddress || record.paymentaddress.length === 0){
                                        // @ts-expect-error explanation: table error type as by defult antd is expecting an empty array
                                        _record.paymentaddress= [{}]
                                    } 
                                    props.setCancellationDetails(record)
                                    props.changeTab('GuaranteePaymentDetail')
                                },
                            };
                        }}
                        // @ts-expect-error explanation: table error type as by defult antd is expecting an empty array
                        rowKey={(item) => { return item.guaranteeid }}
                    />
                </Grid>
            </Grid>
        </Card>
    </PageContainer>)
}

export default GPTable;
